<button
	mat-raised-button
	color="primary"
	[name]="buttonName()"
	[disabled]="(showSpinner() && disabledWhenSpinning()) || disabledByReason()"
	[matTooltip]="toolTip()"
	(click)="onButtonClick()"
	[type]="type()">
	<div class="flex flex-row justify-center items-center">
		@if (showSpinner()) {
			<mat-icon>
				<mat-spinner color="primary" mode="indeterminate" diameter="20"></mat-spinner>
			</mat-icon>
		} @else {
			@if (svgIcon) {
				<mat-icon [svgIcon]="svgIcon"></mat-icon>
			} @else if (matIcon && matIcon.length > 0) {
				<mat-icon>{{ matIcon }}</mat-icon>
			}
		}
		@if (!layoutService.isMobile() && hideTextOnMobile()) {
			<div class="ml-1">
				{{ buttonText() ?? '' }}
			</div>
		}
	</div>
</button>
